import { render, staticRenderFns } from "./Slide4.vue?vue&type=template&id=14df15ef&scoped=true&"
import script from "./Slide4.vue?vue&type=script&lang=js&"
export * from "./Slide4.vue?vue&type=script&lang=js&"
import style0 from "./Slide4.vue?vue&type=style&index=0&id=14df15ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14df15ef",
  null
  
)

export default component.exports